// extracted by mini-css-extract-plugin
export var active = "_hq-c";
export var compactArrow = "_hq-5";
export var container = "_hq-0";
export var dot = "_hq-b";
export var dotContainer = "_hq-a";
export var hoverArrowButton = "_hq-7";
export var hoverArrowContainer = "_hq-6";
export var leftHoverArrowContainer = "_hq-8 _hq-6";
export var rightHoverArrowContainer = "_hq-9 _hq-6";
export var slide = "_hq-4";
export var sliderContainer = "_hq-1";
export var sliderContainerVisibleOverflow = "_hq-2";
export var sliderOverflow = "_hq-3";
export var vignetteBoth = "_hq-f";
export var vignetteLeft = "_hq-e";
export var vignetteRight = "_hq-d";